export default __webpack_public_path__ + "static/Plots0111-4e8e61d432a976666e40271a75b681df.jpg";